import { useState } from "react";
import { validateField } from "../utils/validationUtils";

const useForm = (initialValues = {}, requiredFields = {}, inputTypes = {}) => {
  let num = 0
  const [formData, setFormData] = useState(initialValues);
  const [errors, setErrors] = useState({});
  const [touched, setTouchedState] = useState({});

  const handleInputChange = (name, value) => {
    // console.log(name);

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Validate field on change
    const error = validateField(name, inputTypes[name], value?.trim(), formData, requiredFields);

    //setting errors if any
    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  const handleBlur = (name, value) => {

    // console.log(name);
    // console.log(value);
    
    //sanatizing values
    let sanitizedValue = value?.trim();

    // phone input allow only for specific, numbers, +, and -
    // if (name === "phoneNumber") {
    //   sanitizedValue = value?.trim().replace(/[^0-9+\-]/g, ""); 
    // }

    //set form data after sanatizing
    // console.log(sanitizedValue);
    
    setFormData((prev) => ({
      ...prev,
      [name]: sanitizedValue,
    }));

    setTouchedState((prev) => ({
      ...prev,
      [name]: true,
    }));

  };

  const validateForm = () => {

    const newErrors = {};    

    Object.keys(formData).forEach((key) => {
      newErrors[key] = validateField(key, inputTypes[key], formData[key], formData, requiredFields);
    });

    setErrors(newErrors);    
    // console.log(newErrors);
    
    return Object.values(newErrors).every((error) => error === "");

  };

  const setTouched = (fields) => {
    setTouchedState(fields);
  };
  // console.log(formData);

      
  return {
    formData,
    errors,
    touched,
    handleInputChange,
    handleBlur,
    validateForm,
    setTouched,
    setFormData,
    setErrors
  };
};

export default useForm;
